import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input, NgModule } from '@angular/core';
import * as i2 from '@angular/platform-browser';

class SvgIconComponent {
    constructor(httpClient, sanitizer, changeDetector) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.changeDetector = changeDetector;
        this.style = {};
        this.styleClass = '';
    }
    ngOnChanges() {
        this.loadResource();
    }
    getIconUrl() {
        if (this.srcUrl) {
            return this.srcUrl;
        }
        else if (this.name) {
            return `assets/${this.name}.svg`;
        }
        throw new Error('neither name nor srcUrl passed');
    }
    loadResource() {
        const url = this.getIconUrl();
        this.httpClient.get(url, { responseType: 'text' }).subscribe((value) => {
            this.svgIcon = this.sanitizer.bypassSecurityTrustHtml(value);
            this.changeDetector.markForCheck();
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: SvgIconComponent, deps: [{ token: i1.HttpClient }, { token: i2.DomSanitizer }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.8", type: SvgIconComponent, selector: "pv-svg-icon", inputs: { name: "name", srcUrl: "srcUrl", style: "style", styleClass: "styleClass" }, usesOnChanges: true, ngImport: i0, template: "<div\n  class=\"pv-svg-icon w-1rem h-1rem\"\n  [ngStyle]=\"this.style\"\n  [class]=\"this.styleClass\"\n  [innerHTML]=\"svgIcon\"></div>\n", styles: [".pv-svg-icon>svg{width:100%;height:100%}\n"], dependencies: [{ kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: SvgIconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pv-svg-icon', encapsulation: ViewEncapsulation.None, template: "<div\n  class=\"pv-svg-icon w-1rem h-1rem\"\n  [ngStyle]=\"this.style\"\n  [class]=\"this.styleClass\"\n  [innerHTML]=\"svgIcon\"></div>\n", styles: [".pv-svg-icon>svg{width:100%;height:100%}\n"] }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: i2.DomSanitizer }, { type: i0.ChangeDetectorRef }], propDecorators: { name: [{
                type: Input
            }], srcUrl: [{
                type: Input
            }], style: [{
                type: Input
            }], styleClass: [{
                type: Input
            }] } });
class SvgIconModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: SvgIconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.8", ngImport: i0, type: SvgIconModule, declarations: [SvgIconComponent], imports: [HttpClientModule, CommonModule], exports: [SvgIconComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: SvgIconModule, imports: [HttpClientModule, CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: SvgIconModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SvgIconComponent],
                    exports: [SvgIconComponent],
                    imports: [HttpClientModule, CommonModule],
                }]
        }] });

var publicApi = {};

/**
 * Generated bundle index. Do not edit.
 */

export { SvgIconComponent, SvgIconModule };
